import { render, staticRenderFns } from "./Yihuizong.vue?vue&type=template&id=0515b271&scoped=true"
import script from "./Yihuizong.vue?vue&type=script&lang=js"
export * from "./Yihuizong.vue?vue&type=script&lang=js"
import style0 from "./Yihuizong.vue?vue&type=style&index=0&id=0515b271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515b271",
  null
  
)

export default component.exports